import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { sortBy } from 'lodash';
import { showToast } from 'stores/ToastStore';
import formatMoney from 'utils/formatters/Money';
import { getShipmentDetailUrl } from 'utils/formatters/shipments';
import { getDocumentsV2, getSignedUrl } from 'utils/DocumentsAPIUtils';
import { getShipment } from 'utils/ShipmentWebAPIUtils';
import CapabilityCircle from 'components/modules/user/CapabilityCircle';
import { Translation, withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
function sortJobs(lineItemGroups) {
    return sortBy(lineItemGroups, ['driverName', 'jobDeliverBy']);
}
function renderNoJobs() {
    return (React.createElement(Translation, null, (t, { i18n }) => (React.createElement("div", { className: "job-list" },
        React.createElement("h3", { className: "my-0" }, t('NO_JOBS'))))));
}
function renderJobLoad(load) {
    const rows = [];
    let pallets;
    for (let i = 0; i < load.length; i += 1) {
        pallets = load[i];
        rows.push(pallets.quantity +
            ' (' +
            pallets.width +
            'x' +
            pallets.height +
            'x' +
            pallets.length +
            ')');
        if (i) {
            rows.push(React.createElement("br", null));
        }
    }
    return rows;
}
class JobHistory extends Component {
    constructor(props) {
        super(props);
        this.preparePODOpen = (pod) => (event) => {
            event.preventDefault();
            const windowRef = window.open();
            this.openPOD(pod, windowRef);
        };
        this.openPOD = async (pod, windowRef) => {
            var _a;
            try {
                const { data: signedUrl } = await getSignedUrl(pod);
                windowRef.location = (_a = signedUrl === null || signedUrl === void 0 ? void 0 : signedUrl.getSignedUrl) === null || _a === void 0 ? void 0 : _a.signedUrl;
            }
            catch (e) {
                console.error('job-history: error getting signed URL:', e);
            }
        };
        this.getPOD = async (shipment_id, t) => {
            var _a;
            try {
                const { entity: { item: shipment }, } = await getShipment(shipment_id);
                if (!shipment) {
                    throw new Error('Shipment Not Found');
                }
                const pickupAttempts = shipment.stops.filter((s) => s.attempt && s.action === 'pickup');
                const delivery = sortBy(shipment.stops, 'sequence').find((s) => s.action === 'deliver' && !s.empty);
                if (pickupAttempts.length || (delivery && delivery.attempt)) {
                    return 'Attempt';
                }
                if (delivery) {
                    const { data } = await getDocumentsV2([delivery.id], 'proof_of_delivery', {
                        order: {
                            field: 'createdAt',
                            direction: 'desc',
                        },
                        limit: 1,
                    });
                    const pod = (_a = data === null || data === void 0 ? void 0 : data.getDocumentsV2) === null || _a === void 0 ? void 0 : _a.documents[0];
                    if (pod) {
                        return pod.key;
                    }
                }
                showToast(t('SHIPMENT_MISSING_POD'), null, 'error');
            }
            catch (e) {
                console.error(e);
                showToast(t('ERROR_FETCHING_DOCUMENTS'), null, 'error');
            }
            ;
        };
        this.getPODLink = (shipment_id) => {
            const { t } = this.props;
            return (React.createElement("td", null,
                React.createElement("a", { onClick: (event) => this.handlePODClick(shipment_id, t, event) }, t('POD'))));
        };
        this.renderJobElement = async (lineItemGroup) => {
            const { t } = this.props;
            if (!(lineItemGroup && lineItemGroup.shipment_id)) {
                return (React.createElement("tr", null,
                    React.createElement("td", null, t('MISSING_SHIPMENT_INFO'))));
            }
            const podLinkTd = this.getPODLink(lineItemGroup.shipment_id);
            // Transitional origin/destination
            const originAddress = lineItemGroup.origin
                ? lineItemGroup.origin.address
                : lineItemGroup.originAddress;
            const originName = (lineItemGroup.origin
                ? lineItemGroup.origin.name
                : lineItemGroup.originName) || originAddress;
            const destinationAddress = lineItemGroup.destination
                ? lineItemGroup.destination.address
                : lineItemGroup.destinationAddress;
            const destinationName = (lineItemGroup.destination
                ? lineItemGroup.destination.name
                : lineItemGroup.destinationName) || destinationAddress;
            const momentDeliverBy = moment(lineItemGroup.jobDeliverBy);
            const deliverByDate = momentDeliverBy.isValid()
                ? momentDeliverBy.format('L')
                : lineItemGroup.jobDeliverBy;
            const momentClosed = moment(lineItemGroup.jobClosed);
            const closedDate = momentClosed.isValid()
                ? momentClosed.format('L')
                : lineItemGroup.jobClosed;
            const podVerified = typeof lineItemGroup.is_pod_valid !== 'undefined' &&
                lineItemGroup.is_pod_valid !== null;
            return (React.createElement("tr", { key: lineItemGroup.shipment_id },
                React.createElement("td", null, deliverByDate),
                React.createElement("td", null,
                    React.createElement(Link, { to: getShipmentDetailUrl(lineItemGroup.shipment_id) }, lineItemGroup.shipmentId)),
                React.createElement("td", null,
                    podVerified && (React.createElement(CapabilityCircle, { checked: lineItemGroup.is_pod_valid })),
                    !podVerified && React.createElement("span", null, titleize(t('PENDING')))),
                React.createElement("td", { title: originAddress }, originName),
                React.createElement("td", { title: destinationAddress }, destinationName),
                React.createElement("td", null, renderJobLoad(lineItemGroup.loads)),
                React.createElement("td", null, lineItemGroup.weight),
                React.createElement("td", null, lineItemGroup.driverName),
                React.createElement("td", null, formatMoney(lineItemGroup.total, this.props.currency)),
                podLinkTd,
                React.createElement("td", null, closedDate)));
        };
        this.state = {
            jobList: [],
        };
    }
    async componentDidMount() {
        try {
            const jobList = await Promise.all(sortJobs(this.props.lineItemGroups).map(await this.renderJobElement));
            this.setState({ jobList });
        }
        catch (e) {
            console.error('job-history, failed to get signed URL: ', e);
        }
    }
    async handlePODClick(shipment_id, t, event) {
        const pod = await this.getPOD(shipment_id, t);
        if (pod) {
            const open = this.preparePODOpen(pod);
            open(event);
        }
    }
    ;
    render() {
        const lineItemGroups = this.props.lineItemGroups;
        const { t } = this.props;
        if (!lineItemGroups || lineItemGroups.length === 0) {
            return renderNoJobs();
        }
        const { jobList } = this.state;
        return (React.createElement("div", { className: "overflow-x-auto" },
            React.createElement("table", { className: "default-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, t('DATE', { count: 1 })),
                        React.createElement("th", null, t('SHIPMENT', { count: 1 })),
                        React.createElement("th", null, t('POD_VERIFICATION')),
                        React.createElement("th", null, t('ORIGIN')),
                        React.createElement("th", null, t('DESTINATION')),
                        React.createElement("th", null, t('LOAD')),
                        React.createElement("th", null, t('WEIGHT')),
                        React.createElement("th", null, t('DRIVER', { count: 1 })),
                        React.createElement("th", null, t('TOTAL')),
                        React.createElement("th", null, t('POD')),
                        React.createElement("th", null, t('CLOSED_DATE')))),
                React.createElement("tbody", null, jobList))));
    }
}
JobHistory.propTypes = {
    lineItemGroups: PropTypes.array,
    // context: PropTypes.string.isRequired,
};
JobHistory.defaultProps = {
    lineItemGroups: [],
};
export default withTranslation()(JobHistory);
